import React, { useSyncExternalStore } from "react";
import SearchBar from "../../shared/SearchBar";
import { GOLD_SEARCH_SX } from "../../shared/goldTheme";
import { pageSearchStore } from "../../../helper/pageSearch";

// The main-nav search bar: searches the data of the page that is open. A page
// opts in with usePageSearch() (helper/pageSearch.js); on a page that has no
// search there is nothing to show, so the bar is not rendered.
export default function PageSearchBar() {
  const active = useSyncExternalStore(pageSearchStore.subscribe, pageSearchStore.getActive);
  if (!active) return null;
  return (
    <SearchBar
      value={active.value}
      onChange={(e) => pageSearchStore.setValue(active.id, e.target.value)}
      placeholder={active.placeholder}
      sx={{ width: { xs: "100%", sm: 380, lg: 460 }, maxWidth: "100%", ...GOLD_SEARCH_SX }}
      inputProps={{ onKeyDown: (e) => pageSearchStore.keyDown(active.id, e) }}
    />
  );
}
